import { useState } from "react";
import { FileText, UploadCloud, Phone, Mail, CalendarDays, Award, Euro, History } from "lucide-react";
import { Karte, Pill, OR } from "./DesignBeispiele";

const DOKS = [
  ["Bildungsgutschein", "BG 343D…-01 · 12.09.2026", "gruen"], ["Maßnahmevertrag (FB_TN_02 V02)", "digital unterschrieben 15.09.2026", "gruen"],
  ["Erstgespräch + Technik-Check", "Laptop · Kamera ✓ · Mikro ✓ · 50 Mbit/s", "gruen"], ["Datenschutz", "unterschrieben 15.09.2026", "gruen"],
  ["Praktikumsvertrag", "Homecare – Die Alltagshelfer", "gruen"], ["Laufzettel + Bewertung", "fehlt – Praktikum endet 24.10.", "gelb"],
  ["Prüfung (Upload)", "Termin 07.11.2026", "grau"], ["Zertifikat", "erst nach Prüfung + Laufzettel", "grau"],
];
const VERLAUF = [["Heute 09:12", "Anwesenheit bestätigt (Modul 6)", "#D9775A"], ["13.10.", "Praktikumsstelle telefonisch abgestimmt · A. Lorke", "#D9775A"],
  ["15.09.", "Maßnahmevertrag digital unterschrieben", "#141312"], ["12.09.", "Erstgespräch & Technik-Check durchgeführt", "#8C857F"]];
const TABS = [["Dokumente", FileText], ["Anwesenheit", CalendarDays], ["Prüfungen", Award], ["Rechnungen", Euro], ["Verlauf", History]];

const Ring = ({ pct, farbe, size = 64, children }) => {
  const r = 26, c = 2 * Math.PI * r;
  return (
    <div className="relative" style={{ width: size, height: size }}>
      <svg viewBox="0 0 64 64" className="w-full h-full -rotate-90"><circle cx="32" cy="32" r={r} fill="none" stroke="#F0EEEA" strokeWidth="7" />
        <circle cx="32" cy="32" r={r} fill="none" stroke={farbe} strokeWidth="7" strokeLinecap="round" strokeDasharray={c} strokeDashoffset={c * (1 - pct / 100)} className="transition-all duration-700" /></svg>
      <div className="absolute inset-0 flex items-center justify-center text-sm font-extrabold text-slate-900">{children}</div>
    </div>
  );
};

export const BeispielAkte = () => {
  const [tab, setTab] = useState(0);
  return (
    <div className="space-y-5">
      <Karte className="p-6 flex flex-wrap items-center gap-5 relative overflow-hidden">
        <div className="absolute right-0 top-0 h-full w-40" style={{ background: "repeating-linear-gradient(135deg,#FEF4EE 0 10px,transparent 10px 20px)" }} />
        <div className="w-16 h-16 rounded-2xl flex items-center justify-center text-xl font-extrabold text-white rotate-3" style={{ background: OR }}>MB</div>
        <div className="flex-1 min-w-[220px] relative">
          <div className="flex flex-wrap items-center gap-2"><h2 className="text-2xl font-extrabold tracking-tight text-slate-900" style={{ fontFamily: "inherit" }}>Maria Beispiel</h2><Pill ton="gruen">im Kurs</Pill><Pill ton="blau">Bildungsgutschein</Pill></div>
          <p className="text-sm text-slate-500 mt-1">Pflegehilfskraft & Betreuungsassistent · MN 364 1232 2024 · 15.09.2026 – 05.01.2027</p>
          <div className="flex gap-4 mt-2 text-xs text-slate-500"><span className="flex items-center gap-1"><Phone size={13} />0151 …</span><span className="flex items-center gap-1"><Mail size={13} />maria@beispiel.de</span></div>
        </div>
        <div className="flex gap-4 relative"><Ring pct={92} farbe="#D9775A">92%</Ring><Ring pct={75} farbe={OR}>6/8</Ring></div>
      </Karte>
      <div className="flex gap-1 border-b border-[#ECEAE6]">
        {TABS.map(([t, I], k) => (
          <button key={t} onClick={() => setTab(k)} data-testid={`akte-tab-${k}`} className={`flex items-center gap-2 px-4 py-2.5 text-sm font-semibold border-b-2 -mb-px transition-colors ${k === tab ? "" : "border-transparent text-slate-500 hover:text-slate-800"}`}
            style={k === tab ? { borderColor: OR, color: OR } : undefined}><I size={15} />{t}</button>
        ))}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <Karte className="lg:col-span-2 p-5">
          <div className="flex items-center justify-between mb-3"><p className="font-semibold text-slate-900">Pflichtdokumente AZAV</p><Pill ton="gelb">1 offen</Pill></div>
          <div className="grid sm:grid-cols-2 gap-2">
            {DOKS.map(([n, s, ton]) => (
              <div key={n} className="flex items-start gap-3 p-3 rounded-xl border border-[#F0EEEA] hover:border-[#E2621B]/30 transition-colors">
                <span className={`mt-1 w-2.5 h-2.5 rounded-full shrink-0 ${ton === "gelb" ? "animate-pulse" : ""}`} style={{ background: { gruen: "#D9775A", gelb: "#141312", grau: "#D8D4CC" }[ton] }} />
                <div className="min-w-0"><p className="text-sm font-semibold text-slate-800">{n}</p><p className="text-xs text-slate-500 truncate">{s}</p></div>
              </div>
            ))}
          </div>
          <div className="mt-4 border-2 border-dashed border-[#ECEAE6] hover:border-[#E2621B] hover:bg-[#FEF4EE] rounded-xl p-5 text-center transition-colors cursor-pointer">
            <UploadCloud className="mx-auto text-slate-400" /><p className="text-sm text-slate-600 mt-1">Datei hierher ziehen – Kategorie wird automatisch vorgeschlagen</p>
          </div>
        </Karte>
        <Karte className="p-5">
          <p className="font-semibold text-slate-900 mb-4">Verlauf</p>
          <div className="relative pl-5 space-y-5 before:absolute before:left-[5px] before:top-1 before:bottom-1 before:w-px before:bg-[#ECEAE6]">
            {VERLAUF.map(([d, t, c]) => (
              <div key={t} className="relative"><span className="absolute -left-5 top-1 w-2.5 h-2.5 rounded-full ring-4 ring-white" style={{ background: c }} />
                <p className="text-xs text-slate-400">{d}</p><p className="text-sm text-slate-800">{t}</p></div>
            ))}
          </div>
        </Karte>
      </div>
    </div>
  );
};

const MN = [["Pflegehilfskraft & Betreuungsassistent", "364 1232 2024", 18, 17, 16, 1], ["Pflegeassistent LG1 & LG2", "364 1013 2026", 24, 24, 24, 0], ["Ambulanter Pflegeassistent", "364 1045 2026", 9, 7, 5, 2]];

export const BeispielPruefungen = () => (
  <div className="space-y-5">
    <div><h2 className="text-2xl font-extrabold tracking-tight text-slate-900" style={{ fontFamily: "inherit" }}>Prüfungen & Zertifikate</h2>
      <p className="text-sm text-slate-500">Eine Zählregel für alle Zahlen – Quelle ist immer der Kurs-Eintrag in der Akte.</p></div>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {MN.map(([n, nr, best, pr, ze, off]) => (
        <Karte key={nr} className="p-5 relative overflow-hidden" data-testid={`beispiel-mn-${nr.split(" ")[1]}`}>
          <div className="absolute -right-6 -bottom-6 w-28 h-28 rounded-full" style={{ background: off ? "#FFFBEB" : "#ECFDF5" }} />
          <div className="relative">
            <div className="flex items-start justify-between gap-2"><div><p className="text-xs font-semibold tracking-wider text-slate-400">MN {nr}</p><p className="font-bold text-slate-900 leading-snug mt-1">{n}</p></div>
              <Pill ton={off ? "gelb" : "gruen"}>{off ? `${off} offen` : "vollständig"}</Pill></div>
            <div className="flex items-center gap-4 mt-5">
              <Ring pct={(ze / best) * 100} farbe={off ? "#141312" : "#D9775A"} size={76}>{ze}/{best}</Ring>
              <div className="text-sm space-y-1"><p><b>{best}</b> <span className="text-slate-500">bestanden</span></p><p><b>{pr}</b> <span className="text-slate-500">Prüfung hochgeladen</span></p><p><b>{ze}</b> <span className="text-slate-500">Zertifikat ausgestellt</span></p></div>
            </div>
            {off > 0 && <button className="mt-4 w-full text-sm font-semibold py-2 rounded-full border transition-colors hover:text-white" style={{ borderColor: OR, color: OR }}
              onMouseEnter={(e) => { e.currentTarget.style.background = OR; e.currentTarget.style.color = "#fff"; }} onMouseLeave={(e) => { e.currentTarget.style.background = ""; e.currentTarget.style.color = OR; }}>{off === 1 ? "1 offenen Fall ansehen" : `${off} offene Fälle ansehen`}</button>}
          </div>
        </Karte>
      ))}
    </div>
  </div>
);
